
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Tout savoir sur WordPress Headless, avantages et inconvénients",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez tout sur WordPress Headless : explorez ses avantages, inconvénients et comment il révolutionne la gestion de contenu web.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Tout savoir sur WordPress Headless, avantages et inconvénients",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez tout sur WordPress Headless : explorez ses avantages, inconvénients et comment il révolutionne la gestion de contenu web.",
        },
      ],
    };
  },
};
